import { UploadData, URN } from '@askporter/grieg-types';

export type UploadedFile = UploadData & { name: string; addedAt?: string; error?: unknown };

export interface Media {
  file: {
    fileUrn?: URN;
    filePath?: string;
    fileRef?: URN;
  };

  addedAt: string;
  path?: string;
  nameAndType?: { name: string; type: AllowedFileTypes | null };
}

export enum AllowedFileTypes {
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
  DOC = 'doc',
  DOCX = 'docx',
  PDF = 'pdf',
  MP4 = 'mp4',
  HEIC = 'heic',
  HEIF = 'heif',
}
